import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  copyLinkContainer: {
    cursor: 'pointer',
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.grey[200],
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    maxWidth: '50%',
  },
  copyLink: {
    '&:hover': {
      color: theme.palette.grey[500],
    },
  },
}))

export default styles
